import type { Action } from 'redux';
import type { IAdLinkTemplate } from '../../../../main/types/links';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const AdLinkUpdateSelectedTemplate = new ReduxAsyncAction<
  'AD_LINK_UPDATE_SELECTED_TEMPLATE',
  IAdLinkTemplate,
  { selectedTemplate: IAdLinkTemplate }
>('AD_LINK_UPDATE_SELECTED_TEMPLATE');

AdLinkUpdateSelectedTemplate.registerRequest(
  async (selectedTemplate: IAdLinkTemplate): Promise<{ selectedTemplate: IAdLinkTemplate }> => {
    return { selectedTemplate };
  }
);

export const AD_LINK_UPDATE_SELECTED_TEMPLATE = AdLinkUpdateSelectedTemplate.actionNamespaceConstants;
export const adLinkUpdateSelectedTemplate = AdLinkUpdateSelectedTemplate.request;

export type AdLinkUpdateSelectedTemplateResponseAction = Action<typeof AD_LINK_UPDATE_SELECTED_TEMPLATE.response> & {
  data: { selectedTemplate: IAdLinkTemplate };
};
